module.exports = __webpack_public_path__ + "static/media/md-pulse.70a5f9c1.svg";